// VietQR (napas) helpers. POC uses the img.vietqr.io quick-link image API,
// which renders a real, scannable bank-transfer QR (with bank logo).

export interface VietQrParams {
  bin: string; // napas BIN, vd 970415
  accountNumber: string;
  amount?: number;
  addInfo?: string; // nội dung chuyển khoản
  accountName?: string;
  template?: 'compact' | 'compact2' | 'qr_only' | 'print';
}

export function buildVietQrUrl(p: VietQrParams): string {
  const template = p.template || 'compact2';
  const base = `https://img.vietqr.io/image/${p.bin}-${p.accountNumber}-${template}.png`;
  const q = new URLSearchParams();
  if (p.amount) q.set('amount', String(Math.round(p.amount)));
  if (p.addInfo) q.set('addInfo', p.addInfo);
  if (p.accountName) q.set('accountName', p.accountName);
  const qs = q.toString();
  return qs ? `${base}?${qs}` : base;
}

export const BANKS: { bin: string; name: string }[] = [
  { bin: '970415', name: 'VietinBank' },
  { bin: '970436', name: 'Vietcombank' },
  { bin: '970418', name: 'BIDV' },
  { bin: '970405', name: 'Agribank' },
  { bin: '970407', name: 'Techcombank' },
  { bin: '970403', name: 'Sacombank' },
  { bin: '970422', name: 'MB Bank' },
  { bin: '970432', name: 'VPBank' },
  { bin: '970416', name: 'ACB' },
  { bin: '970423', name: 'TPBank' },
  { bin: '970437', name: 'HDBank' },
  { bin: '970448', name: 'OCB' },
];

export const bankNameByBin = (bin?: string) =>
  BANKS.find((b) => b.bin === bin)?.name || bin || '';
